import { FC, useContext } from 'react';

import { Button, H2, Modal } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { EAdvertisementStatus } from 'types';

import s from './AdvertisementUnpublishedModal.module.scss';
import { IAdvertisementUnpublishedModalProps } from './interfaces';

export const AdvertisementUnpublishedModal: FC<IAdvertisementUnpublishedModalProps> =
  ({
    onClose,
    handledChangeAdvertisementStatus,
    changingStatus,
    data,
    closeViewModal,
  }) => {
    const { t } = useContext(LocalizationContext);

    return (
      <Modal className={s.container} onClose={onClose}>
        <H2>{t('unpublished')}</H2>
        <div className={s.card}>
          <div className={s.left}>
            <img src={data?.images?.[0]} alt={data?.images?.[0]} />
          </div>
          <div className={s.right}>
            <span className={s.title}>{data?.title}</span>
            <span className={s.price}>
              {data?.price} {data?.currency?.letter}
            </span>
          </div>
        </div>
        <div className={s.button_block}>
          <Button
            fullWidth
            onClick={() => {
              if (data)
                handledChangeAdvertisementStatus(
                  data?.id,
                  EAdvertisementStatus.COMPLETED
                ).then(() => {
                  onClose();

                  closeViewModal && closeViewModal();
                });
            }}
            isLoading={changingStatus}
          >
            {t('remove.published')}
          </Button>
          <Button fullWidth variant="secondary" onClick={onClose}>
            {t('cancel')}
          </Button>
        </div>
      </Modal>
    );
  };
